import Axios, { CitCfdiAxios } from '@/services/Axios';
import { ErrorResponse } from '@/common/models/ErrorResponse';
import { TokenUtils } from '@/utils/TokenUtils';
import { PendingInvoiceSaleList } from '../common/models/PendingInvoiceSaleList';
import { SaleNoInvoiceSingleItem } from '../common/models/SaleNoInvoiceSingleItem';

export default {

  async getPendingInvoiceList(
    limit = -1, offset = -1,
    filterInvoice = 1,
  ) {
    const params = {
      limit,
      offset,
      filterInvoice,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      // eslint-disable-next-line no-shadow
      const { data: response } = await Axios.get(
        '/invoice/pending-invoice-sale/list',
        { headers, params },
      );
      return response.map(element => (
        new PendingInvoiceSaleList(
          element.client,
          element.createdDt,
          element.foil,
          element.id,
          element.total,
        )
      ));
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getPendingInvoiceTableCount(
    searchQuery = null,
    startDate = null,
    endDate = null,
    clientId = null,
    paymentMethod = null,
    storeId = null,
  ) {
    const params = {};

    if (!!searchQuery) {
      params.searchQuery = searchQuery;
    }

    if (!!startDate) {
      params.startDate = startDate;
    }

    if (!!endDate) {
      params.endDate = endDate;
    }

    if (!!clientId) {
      params.clientId = clientId;
    }

    if (!!paymentMethod) {
      params.paymentMethod = paymentMethod;
    }

    if (!!storeId) {
      params.storeId = storeId;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get(
        '/invoices/pending-invoice-sale/table-count',
        { headers, params },
      );
      return response.count;
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getPendingInvoiceTable(
    limit, offset,
    searchQuery = null,
    startDate = null,
    endDate = null,
    clientId = null,
    paymentMethod = null,
    storeId = null,
  ) {
    const params = {
      limit,
      offset,
    };

    if (!!searchQuery) {
      params.searchQuery = searchQuery;
    }
    if (!!startDate) {
      params.startDate = startDate;
    }
    if (!!endDate) {
      params.endDate = endDate;
    }
    if (!!clientId) {
      params.clientId = clientId;
    }

    if (!!paymentMethod) {
      params.paymentMethod = paymentMethod;
    }

    if (!!storeId) {
      params.storeId = storeId;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get(
        '/invoices/pending-invoice-sale/table',
        { headers, params },
      );
      const items = response.items.map(element => (
        new SaleNoInvoiceSingleItem(
          element.id,
          element.foil,
          element.createdDt,
          element.total,
          element.paymentMethod,
          element.employee,
          element.store,
          element.client,
          element.creditCardPayments,
          element.debitCardPayments,
        )
      ));
      const { total } = response;
      const totalAmericanExpress = response.totalAmericanExpressPayments;
      return { items, total, totalAmericanExpress };
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getFacturaSale(id, replaceDocumentDt = 0) {
    const params = {
      id,
      replaceDocumentDt,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/facturala/sale', { headers, params });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e));
    }
  },

  async getInvoiceById(id) {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get(`/invoice/${id}`, { headers });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getInvoiceEmmiter() {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/invoice/emitter', { headers });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getClientInvoiceList(
    limit = -1, offset = -1,
  ) {
    const params = {
      limit,
      offset,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/invoice/client/list', { headers, params });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getInvoiceMisc() {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    try {
      const { data: response } = await Axios.get('/invoice/misc', { headers });
      return response;
    } catch (e) {
      console.error(e);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async postFacturalaTestInvoice(factura) {
    const json = JSON.stringify(factura);
    let resp = null;
    try {
      resp = await Axios.post('/facturala/test/sale/invoice', json, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      console.error(e);

      let errorPayload = { message: e };
      if (e.response && e.response.data) {
        errorPayload = e.response.data;
      }
      resp = new ErrorResponse(errorPayload);
    }
    return resp;
  },

  async postFacturalaSaleInvoice(factura) {
    const json = JSON.stringify(factura);
    let resp = null;
    try {
      resp = await Axios.post('/facturala/sale/invoice', json, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      console.error(e);

      let errorPayload = { message: e };
      if (e.response && e.response.data) {
        errorPayload = e.response.data;
      }
      resp = new ErrorResponse(errorPayload);
    }
    return resp;
  },

  async postGlobalSaleInvoice(sales, storeId) {
    const body = {
      sales,
      store_id: storeId,
    };
    const json = JSON.stringify(body);
    let resp = null;
    try {
      resp = await Axios.post('/facturala/global-sales', json, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      console.error(e);
      resp = new ErrorResponse(e);
    }
    return resp;
  },

  async getInvoicesTableCount(
    searchQuery = null,
    startDate = null,
    endDate = null,
  ) {
    const params = {};

    if (!!searchQuery) {
      params.searchQuery = searchQuery;
    }

    if (!!startDate) {
      params.startDate = startDate;
    }

    if (!!endDate) {
      params.endDate = endDate;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get('/invoices/table-count', { headers, params });
      return response.count;
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getInvoicesTable(
    limit, offset,
    searchQuery = null,
    startDate = null,
    endDate = null,
  ) {
    const params = {
      limit,
      offset,
    };

    if (!!searchQuery) {
      params.searchQuery = searchQuery;
    }

    if (!!startDate) {
      params.startDate = startDate;
    }

    if (!!endDate) {
      params.endDate = endDate;
    }

    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      const { data: response } = await Axios.get('/invoices/table', { headers, params });
      return response;
    } catch (e) {
      console.error(e.response);
      throw (new ErrorResponse(e.response.data));
    }
  },

  async getFiscalRegimeById(id) {
    let response = null;
    const data = await Axios.get(`/fiscal-regime/${id}`);
    response = data.data;
    return response;
  },

  async getFiscalRegimeByCode(code) {
    let response = null;
    const data = await Axios.get(`/fiscal-regime/code/${code}`);
    response = data.data;
    return response;
  },

  async getRelationshipTypeFromCitCfdi() {
    let response = null;
    const data = await CitCfdiAxios.get('/sat-tipo-relacion/list');
    response = data.data;
    return response;
  },

  async getCancelationReasonsFromCitCfdi() {
    let response = null;
    const data = await CitCfdiAxios.get('/sat-motivo-cancelacion/list');
    response = data.data;
    return response;
  },

  async getCfdiUseFromCitCfdi() {
    let response = null;
    const data = await CitCfdiAxios.get('/sat-uso-cfdi/list', {
      params: {
        limit: null,
      },
    });
    response = data.data;
    return response;
  },

  async getFiscalRegimesFromCitCfdi(query = '') {
    let response = null;
    const data = await CitCfdiAxios.get('/sat-regimen/list', {
      params: {
        query,
        limit: null,
      },
    });
    response = data.data;
    return response;
  },

  async cancelSaleInvoiceExternal(reason, uuid, sustitucion, rfcReceptor, total, serie, folio) {
    const body = {
      fecha: new Date(),
      folio: {
        uuid,
        motivo: reason,
        folioSustitucion: sustitucion,
      },
      rfc_receptor: rfcReceptor,
      total,
      serie_factura: serie,
      folio_factura: folio,
    };
    try {
      const { data: citCfdiResponse } = await CitCfdiAxios.post('/api/cancel/external', body);
      console.log(citCfdiResponse);
    } catch (error) {
      console.error(error);
      throw new ErrorResponse({
        message: 'Error al cancelar la factura. Intente de nuevo más tarde.',
        detail: error,
      });
    }
  },

  async cancelSaleInvoice(id) {
    try {
      const body = {
        id,
      };
      const headers = {
        Authorization: `Bearer ${TokenUtils.getToken()}`,
      };
      const { data: apiResponse } = await Axios.post('/invoice/cancel', body, { headers });
      return apiResponse;
    } catch (error) {
      throw new ErrorResponse({
        message: 'Error al cancelar la factura. Intente de nuevo más tarde.',
        detail: error,
      });
    }
  },

  async cancelGlobalSaleInvoice(id, uuid, rfcReceptor, total, serie, folio) {
    const body = {
      fecha: new Date(),
      folio: {
        uuid,
        motivo: '04', // Cancelacion de factura global
        folioSustitucion: '',
      },
      rfc_receptor: rfcReceptor,
      total,
      serie_factura: serie,
      folio_factura: folio,
    };
    try {
      const { data: citCfdiResponse } = await CitCfdiAxios.post('/api/cancel/external', body);
      if (citCfdiResponse) {
        const headers = {
          Authorization: `Bearer ${TokenUtils.getToken()}`,
        };
        const { data: apiResponse } = await Axios.post(`/invoice/cancel/global/${id}`, null, { headers });
        return apiResponse;
      }
      throw new ErrorResponse({
        message: 'Error al cancelar la factura. Intente de nuevo más tarde.',
        detail: citCfdiResponse,
      });
    } catch (e) {
      console.error(e.response);
      throw new ErrorResponse({
        message: 'Error al cancelar la factura. Intente de nuevo más tarde.',
        detail: e.response.data,
      });
    }
  },
};
